export const durationMovie = (duration: number): string => {
	const hours = Math.floor(duration / 60);
	const minutes = duration % 60;
	const minutesFormatted = minutes < 10 ? `0${minutes}` : minutes;

	return `${hours}h ${minutesFormatted}min`;
};
